<template>
  <div>
    <nav data-cy="settings-nav">
      <div class="navbar-secondary navbar-items">
        <a
          :href="`/settings/company?company=${activeCompany.id}`"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-font-normal tw-text-base tw-text-gray-800 hover:tw-underline"
          data-cy="settings-company"
        >
          <SvgIcon
            name="library"
            class="tw-mr-2 tw-w-4 tw-h-4 tw-text-gray-600"
          />

          <span>Company</span>
        </a>

        <a
          :href="`/settings/departments?company=${activeCompany.id}`"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-font-normal tw-text-base tw-text-gray-800 hover:tw-underline"
          data-cy="settings-departments"
        >
          <SvgIcon
            name="travel-case"
            class="tw-mr-2 tw-w-4 tw-h-4 tw-text-gray-600"
          />

          <span>Departments</span>
        </a>

        <a
          :href="`/settings/allowances?company=${activeCompany.id}`"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-font-normal tw-text-base tw-text-gray-800 hover:tw-underline"
          data-cy="settings-allowances"
        >
          <SvgIcon
            name="check-circle-solid"
            class="tw-mr-2 tw-w-4 tw-h-4 tw-text-gray-600"
          />

          <span>Allowances</span>
        </a>

        <a
          :href="`/settings/overtime?company=${activeCompany.id}`"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-font-normal tw-text-base tw-text-gray-800 hover:tw-underline"
          data-cy="settings-overtime"
        >
          <SvgIcon
            name="clock"
            class="tw-mr-2 tw-w-4 tw-h-4 tw-text-gray-600"
          />

          <span>Overtime</span>
        </a>

        <a
          :href="`/settings/leave-types?company=${activeCompany.id}`"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-font-normal tw-text-base tw-text-gray-800 hover:tw-underline tw-whitespace-no-wrap"
          data-cy="settings-leave-types"
        >
          <SvgIcon
            name="color-palette"
            class="tw-mr-2 tw-w-4 tw-h-4 tw-text-gray-600"
          />

          <span>Leave Types</span>
        </a>

        <a
          :href="`/settings/holidays?company=${activeCompany.id}`"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-font-normal tw-text-base tw-text-gray-800 hover:tw-underline"
          data-cy="settings-holidays"
        >
          <SvgIcon
            name="globe"
            class="tw-mr-2 tw-w-4 tw-h-4 tw-text-gray-600"
          />

          <span>Holidays</span>
        </a>

        <a
          :href="`/settings/employees?company=${activeCompany.id}`"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-font-normal tw-text-base tw-text-gray-800 hover:tw-underline"
          data-cy="settings-employees"
        >
          <SvgIcon
            name="user-group"
            class="tw-mr-2 tw-w-4 tw-h-4 tw-text-gray-600"
          />

          <span>Employees</span>
        </a>

        <a
          :href="`/settings/calendars?company=${activeCompany.id}`"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-font-normal tw-text-base tw-text-gray-800 hover:tw-underline"
          data-cy="settings-calendars"
        >
          <SvgIcon
            name="calendar"
            class="tw-mr-2 tw-w-4 tw-h-4 tw-text-gray-600"
          />

          <span>Calendars</span>
        </a>

        <a
          :href="`/settings/limits?company=${activeCompany.id}`"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-font-normal tw-text-base tw-text-gray-800 hover:tw-underline"
          data-cy="settings-limits"
        >
          <SvgIcon
            name="tachometer"
            class="tw-mr-2 tw-w-5 tw-h-5 tw-text-gray-600"
          />

          <span>Limits</span>
        </a>

        <a
          :href="`/settings/import?company=${activeCompany.id}`"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-font-normal tw-text-base tw-text-gray-800 hover:tw-underline tw-whitespace-no-wrap"
          data-cy="settings-import"
        >
          <SvgIcon
            name="cloud-upload"
            class="tw-mr-2 tw-w-5 tw-h-5 tw-text-gray-600"
          />

          <span>Data Import</span>
        </a>

        <a
          :href="`/settings/integrations?company=${activeCompany.id}`"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-font-normal tw-text-base tw-text-gray-800 hover:tw-underline"
        >
          <SvgIcon name="code" class="tw-mr-2 tw-w-5 tw-h-5 tw-text-gray-600" />

          <span>Integrations</span>
        </a>

        <a
          :href="`/settings/billing?company=${activeCompany.id}`"
          class="lg:tw-w-full lg:tw-mb-3 tw-px-4 tw-py-3 tw-flex tw-items-center tw-font-normal tw-text-base tw-text-gray-800 hover:tw-underline"
          data-cy="settings-upgrade"
        >
          <SvgIcon
            v-if="!isSubscriptionActive"
            name="rocket-f"
            class="tw-mr-2 tw-w-5 tw-h-5 tw-text-gray-600"
          />

          <SvgIcon
            v-if="isSubscriptionActive"
            name="credit-card"
            class="tw-mr-2 tw-w-4 tw-h-4 tw-text-gray-600"
          />

          <span>{{ billingName }}</span>
        </a>
      </div>
    </nav>
  </div>
</template>

<script>
import Subscription from '@/mixins/Subscription'

export default {
  name: 'SettingsNavbar',

  mixins: [Subscription],

  computed: {
    billingName() {
      return this.isSubscribed ? 'Billing' : 'Upgrade'
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar-secondary {
  @screen lg {
    @apply .w-auto;
  }
}
</style>
